exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-disabled{background-color:#a9a9a9!important}.appoint-alert{border-radius:3px 4px;padding:4px;display:flex;min-height:100%;justify-content:space-between;box-shadow:1px 1px 8px rgba(0,0,0,.2);margin:5px 0;cursor:pointer}.time{text-align:left;font-weight:700}.event-popover{min-width:300px}.title{text-align:center;opacity:0;font-size:14px;width:100%}@media screen and (min-width:768px){.title{opacity:1}}@media screen and (min-width:992px){.title{font-size:16px}}", ""]);

// exports
